import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="character-count"
export default class extends Controller {
  static targets = ["input", "count"]
  static values = { max: Number }

  update() {
    this.countTarget.textContent = `${this.inputTarget.value.length}/${this.maxValue}`
  }
}
